import React, { Component } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { withTranslate } from '../../core/TenantProvider';
import ReferralsNoDataViewStyles from './styles/ReferralsContainer.style';
import IconReferral from './assets/empty_referral.svg';
import IconRegistration from './assets/empty_registration.svg';
import IconTrades from './assets/empty_trades.svg';
import {
    NO_SEARCH_DATA_TYPE,
    REFERRAL_TYPE,
    REGISTRATION_TYPE,
    TRADES_TYPE
} from '../../core/utils/Constants/Constants';

const EMPTY_ICONS_COMPONENTS = {
    referral: IconReferral,
    registration: IconRegistration,
    trades: IconTrades,
    noSearchData: IconReferral
};

interface ReferralsNoDataViewProps extends WithStyles<typeof ReferralsNoDataViewStyles> {
    filterType: string,
    activeTabLabel: string,
    translate: Function,
}

class ReferralsNoDataView extends Component<ReferralsNoDataViewProps, {}> {

    render() {

        const {
            classes,
            filterType,
            translate
        } = this.props;

        const EmptyIconComponent = EMPTY_ICONS_COMPONENTS[filterType];
        let activeTabLabel = translate('referrals.filters.referrals.label');

        switch (filterType) {
            case REFERRAL_TYPE:
                activeTabLabel = translate('referrals.filters.referrals.label');
                break;

            case REGISTRATION_TYPE:
                activeTabLabel = translate('referrals.filters.registrations.label');
                break;

            case TRADES_TYPE:
                activeTabLabel = translate('referrals.filters.trades.label.no.data');
                break;

            case NO_SEARCH_DATA_TYPE:
                activeTabLabel = translate('referrals.filters.nodata.label');
                break;  
        }

        return (
            <div className={classes.emptyData}>
                <img src={EmptyIconComponent} alt={activeTabLabel.toLowerCase()} />
                <h3>{translate('referrals.filters.nodata.header', { activeTabLabel: activeTabLabel.toLowerCase() })}</h3>
                <p>{translate('referrals.filters.nodata.subheader', { activeTabLabel: activeTabLabel.toLowerCase() })}</p>
            </div>
        );
    }
}

export default withTranslate(withStyles(ReferralsNoDataViewStyles)(ReferralsNoDataView));
